import { useTranslation } from 'react-i18next'

import { Tab } from 'components/Tabs'
import { useAbility } from 'providers/casl'
import { PrebidDefaultsPage } from '../PrebidDefaultsPage'
import { DefaultsPageTab } from './types'

export const useDefaultsTabs = (): Tab<DefaultsPageTab>[] => {
  const { t: tProduct } = useTranslation('features/product')
  const ability = useAbility()

  const noAccessToPrebid =
    ability.cannot('access', 'GlobalSetupPage-defaults-prebid') ||
    ability.cannot('access', 'Product-prebidStack')

  return [
    {
      disabled: noAccessToPrebid,
      element: 'prebid-stack',
      label: tProduct('product.prebidStack'),
      page: noAccessToPrebid ? <></> : <PrebidDefaultsPage />,
    },
  ]
}
